import { BILLING_CYCLE } from "@/common/constants";
import { flowTypes, pageConfig } from "@/common/service/page-config";
import { addToCartByCategoryAndBillingCycle, addToCartByPlanCode, planQueryParser } from "@/common/service/flow/utils";
import store from '@/store/index';
import { updatePlansCheckout, UpdateTypes } from '@/common/service/checkout-utils';
import { getBasePlanInfo, getBasePlansFrom } from '@/common/product';
import { plansof } from '@/utils/chain';
import { planTypes, PBX_CATEGORYS } from "@/common/constants";
import { DowngradeFlow } from './helper';
import Biz2Pro from './biz2pro'
import { getDowngradeToProPlusForm } from '../utils.js'
import { checkDownSellForDowngrade } from '@/common/service/validate/downsell';
import { computedPbxBasePlans, computedCallingPlans } from "@/common/service/computers/plans/pbx";

function getDefaultCycle(boughtPlans, defaultBillingCycle) {
  const callingPlan = computedCallingPlans(boughtPlans)[0];
  const pbxBasePlan = computedPbxBasePlans(boughtPlans)[0];

  if (callingPlan) return callingPlan.billing_cycle;
  if (pbxBasePlan?.billing_cycle && pbxBasePlan?.billing_cycle !== BILLING_CYCLE.PAY_AS_YOU_GO) return pbxBasePlan.billing_cycle;
  return defaultBillingCycle;
}

const loadDefaultSelectForProPlus = (boughtPlans = []) => (planList = []) => {

  const { category: targetCategory, planType } = pageConfig?.editConfig || {};
  const { category_codes = [] } = planQueryParser(targetCategory);

  const { planType: boughtBaseType, plans } = getBasePlanInfo(boughtPlans);

  if (boughtBaseType === planTypes.ZOOM_MEETING) {
    const meetingPlan = plans[0];
    const defaultBillingCycle = getDefaultCycle(boughtPlans, BILLING_CYCLE.ANNUAL);
    if (category_codes.length) {
      category_codes
      // Filter out Zoom Phone base plan code.
      .filter(code => code !== PBX_CATEGORYS.ZVP)
      .forEach(code => {
        addToCartByCategoryAndBillingCycle(planList, planType, code, defaultBillingCycle, meetingPlan?.cartInfo?.selected_number || 1);
      });
    } else {
      addToCartByCategoryAndBillingCycle(planList, planType, '', defaultBillingCycle, meetingPlan?.cartInfo?.selected_number || 1);
    }
  }
  if (boughtBaseType === planTypes.ZOOM_ONE_BUNDLE) {
    let _region_qty_map = {}, _billing_cycle = null;
    plans.forEach(item => {
      !_billing_cycle && (_billing_cycle = item.billing_cycle);
      _region_qty_map[item.region] = item?.cartInfo?.selected_number;
    })
    const proPlusPlansOf = plansof(planList).type(planTypes.ZONE_PRO_PLUS)
    .cycle(_billing_cycle);

    proPlusPlansOf.plans.forEach(item => {
      if (_region_qty_map[item.region]) {
        addToCartByPlanCode(planList, item.plan_code, _region_qty_map[item.region])
      }
    })
  }

  // Add Zoom Phone Base Plan To Shopping Cart.
  const pbxBasePlan = computedPbxBasePlans(boughtPlans)[0];
  if (pbxBasePlan?.plan_code) {
    addToCartByPlanCode(planList, pbxBasePlan.plan_code, 1);
  } else {
    addToCartByCategoryAndBillingCycle(planList, planType, PBX_CATEGORYS.ZVP, BILLING_CYCLE.MONTHLY, 1);
  }

  return planList;
}

function submitForProPlus(submitParams) {
  const downgradeForm = getDowngradeToProPlusForm(store.getters);
  if (!downgradeForm) return;
  return updatePlansCheckout(submitParams, downgradeForm.planList, downgradeForm.actionType);
}

const loadDefaultSelectByQuery = (planList) => {
  const hasSelected = planList?.find((p) => p.cartInfo.selected_number > 0);
  if (hasSelected) return planList;
  const { category, planType } = pageConfig.editConfig;

  addToCartByCategoryAndBillingCycle(planList, planType, category, BILLING_CYCLE.MONTHLY, 1);
  return planList;
}

function submitDefault(submitParams) {
  const getters = store.getters;
  const { planType } = pageConfig.editConfig;
  const currentSelectedPlan = getters.getSelectedPlans.find(item => item.type === planType);
  const boughtPlans = getters.boughtPlans;
  const boughtBasePlan = getBasePlansFrom(boughtPlans)?.[0] || {};

  const planList = [{
    quantity: currentSelectedPlan.cartInfo.selected_number,
    planCode: currentSelectedPlan.plan_code,
    oldPlanCode: boughtBasePlan.plan_code,
  }]
  const actionType = UpdateTypes.DOWNGRADE_TO_ZONE_BASIC_PLUS;
  return updatePlansCheckout(submitParams, planList, actionType);
}

export default {
  [flowTypes.downgrade]: class extends DowngradeFlow {
    init_shopping_cart__hook(res) {
      if (planTypes.ZONE_PRO_PLUS === pageConfig.editConfig?.planType) {
        this.loader.push('loadDefaultSelectForProPlus', loadDefaultSelectForProPlus(res.boughtPlans));
      } else {
        this.loader.push('loadDefaultSelectByQuery', loadDefaultSelectByQuery);
      }
    }
    beforeSubmit() { return checkDownSellForDowngrade(store.getters) }
    async submit(submitParams) {
      if (planTypes.ZONE_PRO_PLUS === pageConfig.editConfig?.planType) {
        return submitForProPlus(submitParams);
      } else {
        return submitDefault(submitParams);
      }
    }
  },
  [flowTypes.biz2pro]: Biz2Pro,
};
